<template>
  <div class="rew19_aro_wrap shop">
  <div class="rew19_contents_inner">
      <h2 class="rew19_second_title">나의 정기구매</h2>

      <div class="rew19_sumInstress" v-if="viewData.totalDiscountPriceYear != null">
          <span>지난 1년 간 총 할인 금액 <em class="rew19_point">{{$fmt.WON(viewData.totalDiscountPriceYear)}}</em>원</span>
      </div>

      <div v-if="viewData.graceCouponList != null && viewData.graceCouponList.length > 0">
      <h3 class="rew19-third-title">enJoy 멤버십 VIP에게만 드리는 혜택</h3>
      <div class="rew19-coupon-inventory">
        <ul>
            <li class="active" v-for="(coupon, index) in viewData.graceCouponList" :key="index">
                <div class="semicircle">
                    <p class="rew19-coupon-title">
                        <span>정기구매 건너뛰기 쿠폰</span>
                    </p>
                    <p class="rew19-coupon-infor">
                        <span>15만원 이상, 9.2SV 이상 구매 시</span>
                        <span class="coupon-mb">15만원 이상, 9.2SV 이상 구매 시</span>
                    </p>
                    <p class="rew19-coupon-date">
                        <span>
                            {{coupon.startDate}} ~
                            {{coupon.endDate}}
                        </span>

                        <span class="rew19-coupon-state active" v-if="coupon.useCheck == 'N'">가능</span>
                        <span class="rew19-coupon-state" v-if="coupon.useCheck == 'Y'">사용완료</span>

                    </p>
                </div>
            </li>
        </ul>
      </div>
      </div>

      <h3 class="rew19-third-title" v-if="viewData.totalCount != null">정기구매 <span class="lowTone">총 {{viewData.totalCount}}건</span></h3>
      <!-- 정기구매가 없는 경우 -->
      <div class="rew19_order_box noList" v-if="viewData.master_list == null">
            <p class="flex">정기구매 주문 내역이 없습니다.</p>
      </div>

      <ul class="rew19_inFunction_list">
        <li class="rew19_inFunction_row" v-for="(item) in viewData.master_list" v-bind:key="item.aro_no">
            <ul class="rew19_wrapped_column">
                <li class="mainInfo">
                    <span>{{item.aro_no}} ({{item.payment_count}}회차{{item.isRetention == 'Y'?', 4+1':''}}{{(item.uspan_yn == 'Y' || item.meta_yn == 'Y') && item.saving_percentage != '15'?', '+item.saving_percentage+'%':''}}{{(item.uspan_yn == 'Y' || item.meta_yn == 'Y') && item.saving_percentage == '15'?', 스페셜':''}})</span>
                    <span class="separation">
                      {{item.aroTag}}
                    </span>
                    <a @click="openAroNameChangeDialog(item.aro_no, item.aroTag)" class="rew19_btn_update"><span>수정</span></a>
                </li>
                <li class="subInfo">
                    <span>{{item.ship_name}}({{item.hand_phone}})</span>
                    <span class="separation" v-if="paymentCase == '3'">매월 {{parseInt(item.delivery_day, 10)-7}}일</span>
                    <span class="separation" v-if="paymentCase != '3'">매월 {{item.delivery_day}}일</span>
                    <a class="rew19_btn_blackarrow" @click="onClickDetail(item)"><span>자세히</span></a>
                    <a class="rew19_btn_upDown" @click="toggle(item)" :class="[{state_open:isOpen !== item.aro_no}, {state_close:isOpen === item.aro_no}]"><span>여닫음</span></a>
                </li>
            </ul>

            <div class="rew19_payment_content" v-show="isOpen===item.aro_no">

                <div class="rew19_flex_box" v-for="(pd) in item.aroOrderDetail" v-bind:key="pd.ProductCode">

                    <div class="rew19_payment_list__img">
                        <img :src="pd.pd_img_url1" alt="" title=""
                             onError="imageError(this)" data-error-cnt="0"
                        />
                    </div>

                    <div class="rew19_payment_list__infor">
                        <h4>{{pd.pd_name_kr}}</h4>
                        <ul class="rew19_payment_items flex">
                            <li>
                                <span class="rew19_gDetail">
                                    <i class="rew19_point">{{$fmt.WON(pd.pd_amt)}}</i>
                                     원 / {{pd.pd_count}}개</span>
                            </li>
                        </ul>
                    </div>

                </div>

                <div class="rew19_responsive_btns gepTaye2">
                    <a href="#" class="rew19-btn-pline" @click="onClickDetail(item)">주문 상세/변경</a>
                    <a href="#" class="rew19-btn-pline" @click="openProductChangeDialog(item.aro_no, item.aroOrderDetail, item.prod_add_yn, item.payment_count)" v-if="item.uspan_yn != 'Y' && item.meta_yn != 'Y'">+ 상품 변경/추가</a>
                </div>

                <div class="rew19_report_grayback">
                    <em class="mainInfo">결제예정 <strong>{{$fmt.WON(item.payment_amt)}}</strong>원</em>
                    <span class="subInfo">
                        (총 주문 <strong>{{$fmt.WON(item.totalMembersPrice)}}원</strong>
                        - 정기구매 혜택 <strong>{{$fmt.WON(item.discountPrice)}}원</strong>)
                    </span>
                </div>

            </div>
        </li>

      </ul>

      <!-- TODO : paging 처리 -->
      <page-nav v-if="viewData.master_list != null"
        ref="pageNav"
        :totalItemCount="1"
        :pageNo="1"
        :itemCountPerPage="10"
        :pageGroup="10"
        @onClickPage="onClickPage"
      ></page-nav>

  </div><!--rew19_contents_inner-->

  <product-change-dialog
    :show="productChangeDialogShow"
    :title="'나의 정기구매 주문 상품 변경'"
    :memberId="getMemberId()"
    :prodAppendYn="prodAppendYn"
    ref="productChangeDialog"
    @close="productChange"
  ></product-change-dialog>

  <aro-name-change-dialog
    :show="aroNameChangeDialogShow"
    ref="aroNameChangeDialog"
    @close="aroNameChange"
  ></aro-name-change-dialog>

</div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import ProductChangeDialog from '@/components/popup/ProductChangeDialog';
import AroNameChangeDialog from '@/components/popup/aroNameChangeDialog';

import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import PageNav from "@/components/paging/pageNav";

export default {
  name: "aroList",
  extends: AroBase,
  components: {
    PageNav,
    ProductChangeDialog,
    AroNameChangeDialog
  },
  computed: {
    accordionClasses: function() {
          return {
            'state_close': !this.isOpen,
            'state_open': this.isOpen
          };
        }
  },

  data() {
    //View Data
    return{
      isOpen: false,
      viewData : {
          master_list : []
      },

      //주문상품 변경
      productChangeDialogShow : false,
      productChangeDialog : {},

      // aro 장바구니 이름 변경
      aroNameChangeDialogShow : false,
      aroNameChangeDialog : {},

      prodAppendYn: true,

      paymentCase : "",

      testText : ""
    }
  },

  created() {

  },
  mounted() {
    let _this = this;

    _this.loadList(1);
  },

  methods: {

    /**
     * API Request
     */
    toggle: function(item) {
      //this.isOpen = !this.isOpen;
      if(this.isOpen === item.aro_no){
        this.isOpen = false;
      }else{
        this.isOpen = item.aro_no;
      }
    },

    apiGetAro(pageNo){
        let _this = this;

        return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_aro`, {
          params: {
            isUspan : '',
            page : pageNo,
            countPerPage : 10
          }
        });
    },

     // 주문상품 변경
    apiChangeProduct(aro_no, pd_add_list){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_product`, {
        params: {
          aro_no : aro_no,
          pd_add_list : JSON.stringify(pd_add_list)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    //ARO 변경 가능 여부 체크
    apiCheckAroModifyStatus : function(aro_no){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/modify_status`, {
        params: {
          adpNo : aro_no
        }
      });
    },

    // aro 장바구니 이름 변경
    apiAroPutTags : function(aro_no, aro_tag){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_tags`, {
          params : {
            adpNo : aro_no,
            aroTag : aro_tag
          }
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadList(pageNo){
      let _this = this;

      //init data
      _this.viewData = {
        ..._this.viewData,
        countPerPage : _this.countPerPage,
        page : 1,
        totalHistory : 0,
        history_list : []
      };

      //NetFunnel : 나의 정기구매' 진입 및 검색 버튼 클릭시
      NFStart({projectKey: 'service_1', segmentKey: 'act_17'}, function (response) {
        //show loading
        _this.$showLoading();
        _this.apiGetAro(pageNo).then(res=>{

          if (res.status === 200 && res.data.status === "0000") {
            _this.viewData = {...res.data};

             return _this.apiAutoPaymentDate();
          }else{
            //console.error(res);
            _this.$dialogs.alert(res.data.message).then(res => {});
          }

        }).then(res=>{

          if (res.status === 200 && res.data.status === "0000") {
            if(res.data.result){
              _this.paymentCase = res.data.case
            }else{
              _this.paymentCase = "1";
            }
            return;
          }else{
            _this.$dialogs.alert(res.data.message).then(res => {});
          }
        }).catch(()=>{
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

        }).finally(()=>{
          NFStop();

          //hide loading
          _this.$hideLoading();

          //Pass Paging info
          if(_this.viewData.master_list != null){
            _this.$refs.pageNav.resetVal(
              _this.viewData.totalCount,
              _this.viewData.page,
              _this.countPerPage,
            );
          }
        });
      });
    },

    onClickPage(pageNo){
      let _this = this;

      _this.loadList(pageNo);
    },

    //상세 이동
    onClickDetail(item){
      let _this = this;
      _this.$router.push(`${_this.$aroBasePath}/aroDetail?aro_no=${item.aro_no}`);
    },

    //Open dialog 주문상품 변경
    openProductChangeDialog(aro_no, list, prod_add_yn, payment_count){
      let _this = this;

      //pass data to dialog
      _this.productChangeDialog = {
        ..._this.productChangeDialog,
        pd_list : list,
        aro_no : aro_no,
        aro_payment_count : payment_count,
      };

      if(prod_add_yn == 'N'){
        _this.prodAppendYn = false;
      }else{
        _this.prodAppendYn = true;
      }

      _this.$refs.productChangeDialog.initData(_this.productChangeDialog);
      _this.productChangeDialogShow = true;
    },

    //주문상품 변경
    productChange(isOk, data){
      let _this = this;

      _this.productChangeDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      // 상품 변경 불가능한 상품 비교 로직
      {
        let isChange = true;
        let original_pd_list;
        let aroData = _this.viewData.master_list.filter(item=>{
          //return item.aro_no == data.aro_no;
          if(item.aro_no == data.aro_no){
            original_pd_list = item.aroOrderDetail;
            return item;
          }
        });

        if(aroData[0].prod_add_yn == 'N'){

          if(original_pd_list.length < data.pd_list.length){
            isChange = false;
            _this.$dialogs.alert("상품 정보를 변경할 수 없는 정기구매 입니다.");
            return;
          }

          original_pd_list.filter(before => {
            data.pd_list.filter(after => {
              if(before.pd_id == after.pd_id){
                if(before.pd_count != after.pd_count){
                  isChange = false;
                  return;
                }
              }
            });
          });

          if(!isChange){
            _this.$dialogs.alert("상품 정보를 변경할 수 없는 정기구매 입니다.");
            return;
          }
        }
      }

      let pd_add_list = [];
      for(var num in data.pd_list){
        let item = {};
        item['pd_id'] = data.pd_list[num].pd_id;
        item['pd_count'] = data.pd_list[num].pd_count;
        if(data.pd_list[num].agm_info != undefined){
          item['agm_info'] = data.pd_list[num].agm_info;
        }
        pd_add_list.push(item);
      }

      _this.$showLoading();
      _this.apiCheckAroModifyStatus(data.aro_no).then((res)=>{
          if (res.status === 200 && res.data.status === "0000") {
            return _this.apiChangeProduct(data.aro_no, pd_add_list);
          }else{
            //ARO 변경 불가능한 경우
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
            return null;
        }
      }).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("제품 정보를 변경 하였습니다.")
          .then(res => {});

          _this.onClickDetail(data);
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    //Open dialog aro 장바구니 이름 변경
    openAroNameChangeDialog(aro_no, aro_tag){
      let _this = this;

      //pass data to dialog
      _this.aroNameChangeDialog = {
        ..._this.aroNameChangeDialog,
        aro_no : aro_no,
        aro_tag : aro_tag
      };

      _this.$refs.aroNameChangeDialog.initData(_this.aroNameChangeDialog);
      _this.aroNameChangeDialogShow = true;
    },

    // aro 장바구니 이름 변경
    aroNameChange(isOk, data){
      let _this = this;

      _this.aroNameChangeDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      _this.$showLoading();
      _this.apiAroPutTags(data.aro_no, data.aro_tag).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("장바구니 명칭을 변경 하였습니다.")
          .then(res => {});

          _this.loadList(1);
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },
    apiAutoPaymentDate(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/autoPaymentDate`, {
        params: {}
      });
    }
  }
}
</script>
<style>
.rew19_btn_blackarrow, .rew19_btn_upDown{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/my/aro/list.vue